export enum EEntite {
    ROOT_ENTITE_ID = -1
}
